var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationFilter(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.407,
    height: 29.001,
    viewBox: "0 0 31.407 29.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.407 1)"
  }, /*#__PURE__*/React.createElement("line", {
    x2: 29,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0-1.129v5",
    transform: "translate(0 1.129)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,0,11,9",
    transform: "translate(0 5)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13V0",
    transform: "translate(11 14)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y1: 2,
    x2: 4,
    transform: "translate(11 25)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    y2: 2,
    transform: "translate(29 1)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "square",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.851,0a6.852,6.852,0,0,0-5.828,10.453l5.438,8.763a.571.571,0,0,0,.485.27h0a.571.571,0,0,0,.485-.278l5.3-8.848A6.852,6.852,0,0,0,82.851,0Zm4.9,9.774-4.818,8.044L77.993,9.851a5.713,5.713,0,1,1,9.762-.077Z",
    transform: "translate(-60.078 6.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.425,90a3.425,3.425,0,1,0,3.425,3.425A3.429,3.429,0,0,0,169.425,90Zm0,5.716a2.291,2.291,0,1,1,2.287-2.291A2.293,2.293,0,0,1,169.425,95.716Z",
    transform: "translate(-146.652 -80.386)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationFilter);
export default __webpack_public_path__ + "static/media/location_filter.ca39e507fa2497bc29ae7cbc9248e253.svg";
export { ForwardRef as ReactComponent };